// Datos fijos de la empresa emisora y estados del albarán.
export const EMPRESA = {
  nombre: "ENDLESS COMPUTER",
  persona: "DAVID LÓPEZ COSSIO",
  dni: "52900105J",
  direccion: "C/ CANAL DEL BÓSFORO, 60 4B",
};

export const ESTADOS = [
  { key: "pendiente", label: "Pendiente", badge: "bg-amber-100 text-amber-700", dot: "#f59e0b", rgb: [245, 158, 11] },
  { key: "recogido", label: "Recogido", badge: "bg-blue-100 text-blue-700", dot: "#2563eb", rgb: [37, 99, 235] },
  { key: "entregado", label: "Entregado", badge: "bg-violet-100 text-violet-700", dot: "#7c3aed", rgb: [124, 58, 237] },
  { key: "completado", label: "Completado", badge: "bg-emerald-100 text-emerald-700", dot: "#059669", rgb: [5, 150, 105] },
];

export const getEstado = (key) => ESTADOS.find((e) => e.key === key) || ESTADOS[0];
